import { render, staticRenderFns } from "./ModeChoice.vue?vue&type=template&id=9862acc0&scoped=true&"
import script from "./ModeChoice.vue?vue&type=script&lang=js&"
export * from "./ModeChoice.vue?vue&type=script&lang=js&"
import style0 from "./ModeChoice.vue?vue&type=style&index=0&id=9862acc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9862acc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9862acc0')) {
      api.createRecord('9862acc0', component.options)
    } else {
      api.reload('9862acc0', component.options)
    }
    module.hot.accept("./ModeChoice.vue?vue&type=template&id=9862acc0&scoped=true&", function () {
      api.rerender('9862acc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/ModeChoice.vue"
export default component.exports